<div class="modal-header">
  <h3 class="modal-title" id="modal-header">
    <span i18n="@@duplicateBookingHeaderYouHave">You have </span>
    @if (!displayItinerary) {
      <span i18n="@@duplicateBookingHeaderTrips"> trip(s) </span>
    }
    @if (displayItinerary) {
      <span i18n="@@duplicateBookingHeaderIntinerary"> an itinerary </span>
    }
    <span i18n="@@duplicateBookingHeaderRest"> for this date already, here are the details: </span>
  </h3>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.close()">
    <span aria-hidden="true"><i class="ico-cancel modal_exit_cross"></i></span>
  </button>
</div>
<div class="modal-body" role="document" tabindex="0">
  @for (basketItem of userBooking; track basketItem) {
    <p>
      @for (user of basketItem.users; track user; let i = $index) {
        <b
          >{{ user.title }}. {{ user.forename }} {{ user.surname }}
          @if (i < basketItem.users.length + basketItem.guests?.length - 1) {
            <span>, </span>
          }
        </b>
      }
      @for (user of basketItem.guests; track user; let i = $index) {
        <b
          >{{ user.title }}. {{ user.forename }} {{ user.surname }}
          @if (i < basketItem.guests?.length) {
            <span>, </span>
          }
        </b>
      }
    </p>
    <app-duplicate-booking-modal-body
      [basketItem]="basketItem"
      [user]="user"
    ></app-duplicate-booking-modal-body>
  }
</div>
<div class="modal-footer">
  <div
    role="group"
    aria-labelledby="duplicate-booking-warning-question"
    class="flex-row-container flex-row-container--between flex-row-container--full-width flex-row-container--v-center"
  >
    <div
      id="duplicate-booking-warning-question"
      class="flex-row-container"
      i18n="@@duplicate-booking-warning"
    >
      Would you like to continue with this booking?
    </div>
    <div class="flex-row-container button-container">
      <button (click)="activeModal.close(true)" appButton="small">
        <span i18n="@@duplicate-booking-cancel">Cancel</span>
      </button>
      <button (click)="activeModal.close()" appButton="small">
        <span i18n="@@duplicate-booking-ok">Ok</span>
      </button>
    </div>
  </div>
</div>
